"use client";
import React from 'react';

export default function CategoryCard({ category, onClick }){
  const img = category?.image || '';
  return (
    <div className="category-card" onClick={() => onClick && onClick(category)}>
      <div className="card-media">
        <img src={img} alt={category?.name} loading="lazy" />
      </div>
      <div className="category-info">
        <h3 className="category-name">{category?.name}</h3>
        <span className="category-count">{category?.count ?? 0} Items</span>
      </div>
    </div>
  );
}
